import React from "react";
import { Link } from "@remix-run/react";
import { ClientOnly } from "@core/components/client-only";
import { InOfficeOrderNavLink } from "@/overrides/med/components/InOfficeOrderNavLink";
import { ResourceCenterNavLink } from "@/overrides/site/components/ResourceCenterNavLink";
import { useSiteNav } from "@/overrides/site/SiteNavContext";
import type { SiteNavLink } from "@/overrides/site/siteNav";

function NavEntry({ item, nested = false }: { item: SiteNavLink; nested?: boolean }) {
  if (item.behavior === "in-office") {
    return (
      <ClientOnly fallback={null}>
        <InOfficeOrderNavLink label={item.label} href={item.href} />
      </ClientOnly>
    );
  }
  if (item.behavior === "resource-center") {
    return (
      <ClientOnly fallback={null}>
        <ResourceCenterNavLink label={item.label} href={item.href} />
      </ClientOnly>
    );
  }
  if (!nested && item.children.length > 0) {
    return (
      <div className="nav-dropdown">
        <Link to={item.href} className="nav-dropdown-trigger">
          {item.label}
        </Link>
        <div className="nav-dropdown-menu">
          {item.children.map((child) => (
            <NavEntry key={child.id} item={child} nested />
          ))}
        </div>
      </div>
    );
  }
  return <Link to={item.href}>{item.label}</Link>;
}

/** Public header. Labels, links, and which items exist come from Site Navigation. */
const HomepageTabs: React.FC = () => {
  const items = useSiteNav();
  return (
    <>
      {items.map((item) => (
        <NavEntry key={item.id} item={item} />
      ))}
    </>
  );
};

export default HomepageTabs;
